import {Component, Input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
    standalone: true,
    selector: 'text-with-icon',
    templateUrl: './text-with-icon.component.html',
    styleUrls: ['text-with-icon.component.css']
})
export class TextWithIcon {
    @Input() icon: string | null = null;
    @Input() title: string | null = null;
}
